import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { StringUtility } from "../../../system/StringUtility";
import { IHisInformationValue, HisInformationTextValue } from "../../HisInformationValue";

/** HIS項目患者フリガナを変換する */
export class PtKanaBehavior implements IHisInfoItemBehavior {
  private static readonly Key = "PT_KANA";
  
  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const values = hisInfoItems.filter(x => x.name === PtKanaBehavior.Key).map(x => x.value);
    const ptName = values.map(x => StringUtility.convertKanaFromHalfToFull(x));
    return new HisInformationTextValue(PtKanaBehavior.Key, ptName);
  }
}
